import { ToJsonWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ToJson')
export class ToJsonConnectorProvider extends ConnectorProvider<ToJsonWorkflowNode> {}
